var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117.25 94.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#00377b;stroke-miterlimit:10;stroke-width:3px;}.cls-2{fill:#00377b;}.cls-2,.cls-3{stroke-width:0px;}.cls-3{fill:#fdb933;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111 79.5 117 73.5 117.25 88.25 111.25 94.5 111 79.5 111 79.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111 61.75 117 55.75 117.25 70.5 111.25 76.5 111 61.75 111 61.75"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111 43.75 117 37.75 117.25 52.5 111.25 58.75 111 43.75 111 43.75"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111 26 117 20 117.25 34.75 111.25 40.75 111 26 111 26"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111 8 117 2 117.25 16.75 111.25 23 111 8 111 8"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "19 52.5 58.75 18.5 63.25 23.5 70.5 0 46 3.5 50.5 8.75 10.75 43 19 52.5 19 52.5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "4.25 48.5 12.5 58.25 16.5 54.75 8.25 45.25 4.25 48.5 4.25 48.5"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 52.25 8.25 61.75 10.75 59.5 2.5 50 0 52.25 0 52.25"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12 58.5 12 58.5 10.75 59.5 10.75 59.5 9.5 60.75 12.75 64.5 15.25 62.25 12 58.5 12 58.5 12 58.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.25,56.5l.75.75-.75.75-.75-.75.75-.75h0ZM17.5,53.75l-3.75,3.25,3.25,3.75,3.75-3.25-3.25-3.75h0Z"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "69 4.5 68.5 6.75 71 6.25 65.75 23 64 20.75 63.25 23 66.75 27 73.75 4 69 4.5 69 4.5"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.75 18.5 57.25 19.75 59.25 22 23.5 52.5 21.75 50.25 20 51.75 23.25 55.5 62 22.25 58.75 18.5 58.75 18.5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.5 60.25 38.75 57 51.25 57 51.25 57.75 48.75 60.25 35.5 60.25 35.5 60.25"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56 42.5 59.25 39.25 71.75 39.25 71.75 39.75 69.25 42.5 56 42.5 56 42.5"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.5 24.5 79.75 21.25 92.5 21.25 92.5 22 89.75 24.5 76.5 24.5 76.5 24.5"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.75 78.25 18 75 30.75 75 30.75 75.5 28 78.25 14.75 78.25 14.75 78.25"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.25 6.75 100.5 3.5 113.75 3.5 110.5 6.75 97.25 6.75 97.25 6.75"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.5 58.75 55.5 58.75 52.5 58.75 52.5 58.5 49.25 61.75 49.5 76.5 52.5 73.25 52.5 61.75 55.5 58.75 55.5 58.75"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.75 59 75.75 58.75 73.25 58.75 73.25 58.25 69.75 61.75 69.75 76.5 73.25 73.25 73.25 61.75 75.75 59 75.75 59"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "96.5 59 96.5 58.75 94 58.75 94 58.25 90.5 61.75 90.5 76.5 93.75 73.25 93.75 61.75 96.5 59 96.5 59"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.75 41.25 75.75 40.75 73.25 40.75 73.25 40.5 69.75 43.75 69.75 58.75 73.25 55.25 73.25 43.75 75.75 41.25 75.75 41.25"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "96.5 41.25 96.5 40.75 94 40.75 94 40.25 90.5 43.75 90.5 58.75 93.75 55.25 93.75 43.75 96.5 41.25 96.5 41.25"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "96.5 23.25 96.5 23 94 23 94 22.5 90.5 26 90.5 40.75 93.75 37.5 93.75 26 96.5 23.25 96.5 23.25"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.75 76.75 75.75 76.5 73.25 76.5 73.25 76.25 69.75 79.5 69.75 94.5 73.25 91 73.25 79.5 75.75 76.75 75.75 76.75"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.5 76.75 55.5 76.5 52.5 76.5 52.5 76.25 49.25 79.5 49.5 94.5 52.5 91.25 52.5 79.5 55.5 76.75 55.5 76.75"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "34.75 76.75 34.75 76.5 32.25 76.5 32.25 76.25 28.75 79.5 28.75 94.5 32 91 32 79.5 34.75 76.75 34.75 76.75"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "96.5 77 96.5 76.5 94 76.5 94 76 90.5 79.5 90.5 94.5 93.75 91 93.75 79.5 96.5 77 96.5 77"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13 93 12.75 81 27.25 81 27.5 93 13 93 13 93"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.5 93 33.5 81 48 81 48 93 33.5 93 33.5 93"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.5 75 33.5 63.25 48 63.25 48 75 33.5 75 33.5 75"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54 93 54 81 68.25 81 68.5 93 54 93 54 93"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54 75 54 63.25 68.25 63.25 68.5 75 54 75 54 75"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54 57.25 54 45.25 68.25 45.25 68.5 57.25 54 57.25 54 57.25"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.75 93 74.5 81 89 81 89 93 74.75 93 74.75 93"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.75 75 74.5 63.25 89 63.25 89 75 74.75 75 74.75 75"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.75 57.25 74.5 45.25 89 45.25 89 57.25 74.75 57.25 74.75 57.25"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.75 39.25 74.5 27.5 89 27.5 89 39.25 74.75 39.25 74.75 39.25"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.25 93 95.25 81 109.75 81 109.75 93 95.25 93 95.25 93"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.25 75 95.25 63.25 109.75 63.25 109.75 75 95.25 75 95.25 75"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.25 57.25 95.25 45.25 109.75 45.25 109.75 57.25 95.25 57.25 95.25 57.25"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.25 39.25 95.25 27.5 109.75 27.5 109.75 39.25 95.25 39.25 95.25 39.25"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.25 21.5 95.25 9.5 109.75 9.5 109.75 21.5 95.25 21.5 95.25 21.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand-logo.1700acbdf26f1ec47c8536f1e7566e0d.svg";
export { ForwardRef as ReactComponent };